import ProposalLayout from './ProposalLayout';

export default ProposalLayout;
